import { darkenColor, stringToColor } from '~/utils/color_utils';

export default {
  methods: {
    darkenColor,
    stringToColor,
  },
};
